<template>
  <div class="main-page">
    <HomePage v-if="active == 0" />
    <MyPage v-if="active == 1" />
    <van-tabbar v-model="active" @change="onChange">
      <van-tabbar-item icon="home-o">首页</van-tabbar-item>
      <van-tabbar-item icon="setting-o">我的</van-tabbar-item>
    </van-tabbar>
  </div>
</template>

<script setup>
import { ref, computed } from 'vue';
import HomePage from './HomePage.vue'; // 假设您有一个HomePage组件
import MyPage from './myinfo/MyPage.vue'; // 假设您有一个MyPage组件
import wechatUtil from '../global/WechatUtil.js';
import { onMounted } from 'vue';
import store from '@/store/index.js';
import env from '@/global/env';
import account from '@/api/account';
import util from '@/global/util';
import { Toast } from "@vant/compat";
import logger from '@/global/logger.js';
import { useRouter } from 'vue-router'

const router = useRouter();

onMounted(() => {
  wechatUtil.registWx();
  checkAuth();
});

const checkAuth = async () => {
  // 这里可以添加检查用户是否登录的逻辑
  let authed = await store.dispatch('checkAuthStatus');
  if (!authed) {
    active.value = 1;
  }
};
const handleQrScan = () => {
  logger.log('点击了扫码');
  if (env.isTestEnv) {
    router.push({ path: '/signupMatchSubject', query: { id: '8640b19c-0e77-49b1-854d-f4ebcdbd090d' } });
  }
  else {
    util.goToScanCode();
  }
};

const active = computed({
  get: () => store.state.activeTab,
  set: (value) => store.commit('setActiveTab', value)
});
const onChange = (index) => {
  // if (index === 1) {
  //   handleQrScan();
  // }
}
</script>

<style scoped>
.main-page {
  /* 您可以根据需要添加样式 */
}
</style>
